// extracted by mini-css-extract-plugin
module.exports = {"klaviyo_form":"Klaviyo_klaviyo_form__JQ5UB"};